import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function AiRobotIcon({
  className,
  fill,
  height,
  stroke = 'currentColor',
  width,
}: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill={fill ?? 'none'}
      height={height ?? '32'}
      viewBoxDimensions="0 0 32 32"
      width={width ?? '32'}
    >
      <path
        d="M16 10.6667V5.33334H10.6666"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M24 10.6667H8.00004C6.52728 10.6667 5.33337 11.8606 5.33337 13.3333V24C5.33337 25.4727 6.52728 26.6667 8.00004 26.6667H24C25.4728 26.6667 26.6667 25.4727 26.6667 24V13.3333C26.6667 11.8606 25.4728 10.6667 24 10.6667Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M2.66663 18.6667H5.33329"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M26.6666 18.6667H29.3333"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M20 17.3333V20"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M12 17.3333V20"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SimpleIcon>
  );
}
